import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const Suptitle = styled.div`
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: light;
`

const MainTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  margin: 0;
  color: var(--dark);
  @media (min-width: ${breakpoints.small}px) {
    font-size: 38px;
  }
`

const Subtitle = styled.div`
  max-width: 455px;
  font-size: 16px;
  line-height: 1.7;
`

const Title = ({ suptitle, title, subtitle, yellow }) => {
  if (!suptitle && !title && !subtitle) {
    return null
  }

  return (
    <div className="title">
      {suptitle && <Suptitle>{suptitle}</Suptitle>}
      <MainTitle>{title}</MainTitle>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </div>
  )
}

Title.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  yellow: PropTypes.bool,
}

Title.defaultProps = {
  yellow: false,
}

export { Title }
